module.exports = __webpack_public_path__ + "static/my-brother-55f277b8847d9472d3cb6d9d0b9f1278.jpg";